import { useTourCountrySelectedTag } from './useTourCountrySelectedTag';
import { useTourCountryTagsAdapters } from './useTourCountryTagsAdapters';
import { useTourCountryTagsFiltering } from './useTourCountryTagsFiltering';
import { useTourCountryVisibleTags } from './useTourCountryVisibleTags';
import type { Ref } from 'vue';
import type { CountryTag, RegionTagUrls } from '@/shared/api/experience';

export function useTourCountryRubrics(countryTags: Ref<CountryTag[] | undefined>, isMobile: Ref<boolean>) {
  const context = computed(() => 'tours' as keyof RegionTagUrls);

  const { selectedValue, cachedSelectedValue } = useTourCountrySelectedTag(countryTags, context);
  const { popupTags, rubricsTags } = useTourCountryTagsFiltering(countryTags, context);
  const { popupTagsMapped, rubricsAdapters } = useTourCountryTagsAdapters(rubricsTags, popupTags, context);
  const { visibleTags } = useTourCountryVisibleTags(rubricsAdapters, selectedValue, isMobile);

  return {
    selectedValue,
    cachedSelectedValue,
    popupTagsMapped,
    rubricsAdapters,
    visibleTags,
  };
}
